<template>
  <section>
    <span
      class="tag has-text-weight-semibold"
      :class="size"
      :style="{ color: textColor, backgroundColor: backgroundColor }"
      :data-e2e="AppCypressAttribute.status.views.TEXT"
    >
      <slot name="prefix" />
      <div>{{ translatedText }}</div>
      <slot name="suffix" />
    </span>
  </section>
</template>

<script>
import { AppCypressAttribute } from '/@/modules/core/app/constants/AppCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'Status',
  slotsDefinition: {
    prefix: {},
    suffix: {}
  },
  props: {
    text: {
      type: String
    },
    color: {
      type: String,
      default: '#7E84A3'
    },
    isLight: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'is-size-6',
      validator: (prop) => prop.startsWith('is-size-')
    }
  },
  static: {
    AppCypressAttribute
  },
  computed: {
    textColor() {
      return this.isLight ? `${this.color}` : '#ffffff';
    },
    backgroundColor() {
      return this.isLight ? `${this.color}1A` : `${this.color}`;
    },
    translatedText() {
      return this.text ? this.$t(this.text) : '';
    }
  }
};
</script>
